import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import Link from '@material-ui/core/Link';
import { useSelector } from 'react-redux';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Button} from '@material-ui/core';

const useStyles = makeStyles(() => ({
    modalClassConDSIDark: {
        backgroundColor: '#292929',
    },
    modalText: {
        position: 'absolute',
        top: '10px',
        right: '10px'
    },
    buttonGroup: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '10px',
        marginTop: '15px'
    }
}));

const AlignmentExportModal = (props) => {
    const classes = useStyles();
    const toggle = useSelector((state) => state.setToggle.toggle);
    const [exportType, setExportType] = useState('HTML');

    const closeModal = () => {
        props.closeModal();
    };

    const handleExport = () => {
        switch (exportType) {
            case 'HTML':
                props.downloadAlignmentPair('HTML');
                break;
            case 'DOC':
                props.downloadAlignmentPair('DOC');
                break;
            case 'EXCEL':
                props.downloadAlignmentPair('EXCEL');
                break;
            case 'COPY':
                props.handleCopyAll();
                break;
            default:
                break;
        }
        closeModal();
    };

    return (
        <Modal
            size='sm'
            centered
            show={props.showModal}
            contentClassName={toggle ? classes.modalClassConDSI : classes.modalClassConDSIDark}
        >
            <Link href="#" onClick={(e) => e.preventDefault()} className={classes.modalText}>
                <CloseIcon style={{ fill: '#777777' }} onClick={closeModal} />
            </Link>

            <div style={{ padding: '20px' }}>
                <FormControl component="fieldset">
                    <FormLabel ><b>Choose Export Type</b></FormLabel>
                    <RadioGroup
                        value={exportType}
                        onChange={(e) => setExportType(e.target.value)}
                    >
                        <FormControlLabel value="HTML" control={<Radio style={{ color: toggle ? '' : 'white' }}/>} label="HTML Document" />
                        <FormControlLabel value="DOC" control={<Radio style={{ color: toggle ? '' : 'white' }}/>} label="Word Document" />
                        <FormControlLabel value="EXCEL" control={<Radio style={{ color: toggle ? '' : 'white' }}/>} label="Excel Document" />
                        <FormControlLabel value="COPY" control={<Radio style={{ color: toggle ? '' : 'white' }}/>} label="Copy to clipboard" />
                    </RadioGroup>
                </FormControl>

                <div className={classes.buttonGroup}>
                    <Button style={{ color: toggle ? '' : 'white' }} onClick={closeModal}>Cancel</Button>
                    <button type="button" class="cancelButtonClass  btn btn-primary" onClick={handleExport} >Export</button>
                </div>
            </div>
        </Modal>
    );
};

export default AlignmentExportModal;
